import React, { useState } from 'react';
import './Wrappers.css';
import { useCart } from '../context/CartContext';

function Wrappers({ setCurrentSection, setQuoteProduct }) {
  const { addToCart } = useCart();

  const createProductsForZone = (zone) => {
    const styles = [
      'Festival Weave',
      'Royal Heritage',
      'Ceremonial Print',
      'Contemporary Luxe',
      'Classic Threadwork',
      'Modern Royalty',
    ];
    const measurements = ['3 yards', '4 yards', '5 yards', '6 yards', '8 yards', '10 yards'];
    const vendorNames = [
      'Amina Textile House',
      'Binta Weaves',
      'Zara Heritage Studio',
      'Korede Looms',
      'Madaki Prints',
      'Sade Fabrics',
      'Tunde Atelier',
      'Nneka Originals',
      'Ayo Threadworks',
      'Musa Premium Cloth',
    ];
    const locations = ['Kano', 'Lagos', 'Abuja', 'Enugu', 'Port Harcourt', 'Ibadan', 'Kaduna', 'Owerri', 'Ado-Ekiti', 'Maiduguri'];
    const images = [
      'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=900&q=80',
      'https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=900&q=80',
    ];
    const zonePatternImages = {
      'north-west': '/Pattern 1.jfif',
      'north-east': '/pattern 2.jfif',
      'north-central': '/pattern 3.jfif',
      'south-west': '/pattern 4.jfif',
      'south-east': '/pattern 5.jfif',
      'south-south': '/pattern 6.jfif',
    };

    if (zone.id === 'north-west') {
      const northWestDesigns = [
        { name: 'Hausa Indigo Royal', vendor: 'Mairama Heritage Looms', location: 'Kano, Nigeria', tribe: 'Hausa', image: '/Pattern 1.jfif' },
        { name: 'Fulani Sunset Weave', vendor: 'Sadiya Fulani Atelier', location: 'Sokoto, Nigeria', tribe: 'Fulani', image: '/Pattern 1.jfif' },
        { name: 'Adara Festival Cloth', vendor: 'Adaeze Adara House', location: 'Kaduna, Nigeria', tribe: 'Adara', image: '/Pattern 1.jfif' },
        { name: 'Hausa Royal Pattern', vendor: 'Amina Textiles House', location: 'Zaria, Nigeria', tribe: 'Hausa', image: '/Pattern 1.jfif' },
        { name: 'Fulani Moonlight Kente', vendor: 'Halima Fulani Studio', location: 'Katsina, Nigeria', tribe: 'Fulani', image: '/Pattern 1.jfif' },
        { name: 'Adara Heritage Wrap', vendor: 'Titi Adara Looms', location: 'Kafanchan, Nigeria', tribe: 'Adara', image: '/Pattern 1.jfif' },
        { name: 'Hausa Court Weave', vendor: 'Binta Royal Fabrics', location: 'Kano, Nigeria', tribe: 'Hausa', image: '/Pattern 1.jfif' },
        { name: 'Fulani Desert Silk', vendor: 'Hajara Fulani Atelier', location: 'Birnin Kebbi, Nigeria', tribe: 'Fulani', image: '/Pattern 1.jfif' },
        { name: 'Adara Bronze Thread', vendor: 'Nene Adara Textiles', location: 'Kaduna, Nigeria', tribe: 'Adara', image: '/Pattern 1.jfif' },
        { name: 'Hausa Palace Print', vendor: 'Zara Heritage Weaves', location: 'Kano, Nigeria', tribe: 'Hausa', image: '/Pattern 1.jfif' },
        { name: 'Fulani Sunrise Draping', vendor: 'Safiya Silk House', location: 'Gusau, Nigeria', tribe: 'Fulani', image: '/Pattern 1.jfif' },
        { name: 'Adara Ceremonial Layer', vendor: 'Ladi Adara Studio', location: 'Jos, Nigeria', tribe: 'Adara', image: '/Pattern 1.jfif' },
        { name: 'Hausa Market Pride', vendor: 'Aisha Loom Collective', location: 'Kano, Nigeria', tribe: 'Hausa', image: '/Pattern 1.jfif' },
        { name: 'Fulani Golden Emboss', vendor: 'Rabiatu Fulani Weaves', location: 'Sokoto, Nigeria', tribe: 'Fulani', image: '/Pattern 1.jfif' },
        { name: 'Adara Earth Motif', vendor: 'Zainab Adara Atelier', location: 'Kaduna, Nigeria', tribe: 'Adara', image: '/Pattern 1.jfif' },
        { name: 'Hausa Tribal Glory', vendor: 'Hajiya Royal Thread', location: 'Zaria, Nigeria', tribe: 'Hausa', image: '/Pattern 1.jfif' },
        { name: 'Fulani Evening Blend', vendor: 'Samira Fulani Textiles', location: 'Katsina, Nigeria', tribe: 'Fulani', image: '/Pattern 1.jfif' },
        { name: 'Adara Sunset Wrap', vendor: 'Dahiru Adara House', location: 'Kafanchan, Nigeria', tribe: 'Adara', image: '/Pattern 1.jfif' },
        { name: 'Hausa Festival Luxe', vendor: 'Nura Premium Cloth', location: 'Kano, Nigeria', tribe: 'Hausa', image: '/Pattern 1.jfif' },
        { name: 'Fulani Heritage Silk', vendor: 'Aisha Fulani Looms', location: 'Bauchi, Nigeria', tribe: 'Fulani', image: '/Pattern 1.jfif' },
      ];

      return northWestDesigns.map((design, index) => ({
        id: `${zone.id}-${index + 1}`,
        name: design.name,
        vendor: design.vendor,
        location: design.location,
        tribe: design.tribe,
        measurement: measurements[index % measurements.length],
        price: 42 + (index % 8) * 7,
        image: design.image,
        spotlight: `${zone.title} heritage drop`,
      }));
    }

    return Array.from({ length: 20 }, (_, index) => {
      const tribe = zone.tribes[index % zone.tribes.length];
      const style = styles[index % styles.length];
      const vendor = vendorNames[index % vendorNames.length];
      const location = locations[index % locations.length];
      const measurement = measurements[index % measurements.length];
      const price = 38 + (index % 9) * 7;
      const image = zonePatternImages[zone.id] || images[index % images.length];

      return {
        id: `${zone.id}-${index + 1}`,
        name: `${tribe} ${style}`,
        vendor,
        location,
        tribe,
        measurement,
        price,
        image,
        spotlight: `${zone.title} exclusive drop`,
      };
    });
  };

  const zones = [
    {
      id: 'north-west',
      title: 'North West',
      short: 'Hausa • Fulani • Adara',
      description: 'Rich Hausa and Fulani textile traditions with bold geometry, deep indigo, and ceremonial elegance.',
      emoji: '🪶',
      tribes: ['Hausa', 'Fulani', 'Adara', 'Gbagyi'],
      accent: 'north-west',
    },
    {
      id: 'north-east',
      title: 'North East',
      short: 'Kanuri • Shuwa • Tangale',
      description: 'Vivid desert-inspired cloth, hand-finished prints, and heritage pieces from the northeast belt.',
      emoji: '🌅',
      tribes: ['Kanuri', 'Shuwa', 'Tangale', 'Mumuye'],
      accent: 'north-east',
    },
    {
      id: 'north-central',
      title: 'North Central',
      short: 'Nupe • Gbagyi • Ebira',
      description: 'Refined patterns shaped by the middle belt, featuring earthy colors and expressive woven detail.',
      emoji: '🌿',
      tribes: ['Nupe', 'Gbagyi', 'Ebira', 'Idoma'],
      accent: 'north-central',
    },
    {
      id: 'south-west',
      title: 'South West',
      short: 'Yoruba • Egba • Ijesha',
      description: 'Luxury Yoruba textiles with striking wrappers, premium aso-oke, and festival-ready statement pieces.',
      emoji: '🌺',
      tribes: ['Yoruba', 'Egba', 'Ijesha', 'Ijebu'],
      accent: 'south-west',
    },
    {
      id: 'south-east',
      title: 'South East',
      short: 'Igbo • Ikwere • Efik',
      description: 'Fresh contemporary designs from the eastern corridor with elegant motifs and smart tailoring energy.',
      emoji: '✨',
      tribes: ['Igbo', 'Ikwere', 'Efik', 'Ibibio'],
      accent: 'south-east',
    },
    {
      id: 'south-south',
      title: 'South South',
      short: 'Urhobo • Itsekiri • Kalabari',
      description: 'Ocean-influenced, richly layered textiles with cultural symbolism and premium craftsmanship.',
      emoji: '🌊',
      tribes: ['Urhobo', 'Itsekiri', 'Kalabari', 'Ijaw'],
      accent: 'south-south',
    },
  ].map((zone) => ({ ...zone, products: createProductsForZone(zone) }));

  const [activeZone, setActiveZone] = useState(zones[0].id);
  const [showZonePanel, setShowZonePanel] = useState(true);
  const [quoteMessage, setQuoteMessage] = useState('');

  const activeZoneData = zones.find((zone) => zone.id === activeZone) || zones[0];

  const handlePurchase = (product) => {
    addToCart(product);
    setCurrentSection('checkout');
  };

  const handleQuoteRequest = (product) => {
    setQuoteProduct(product);
    setQuoteMessage(`Quote request ready for ${product.name} from ${product.vendor}.`);
    setCurrentSection('quote');
  };

  return (
    <div className="wrappers-section">
      <div className="wrappers-hero">
        <div className="hero-copy">
          <p className="eyebrow">Nigerian Textile Marketplace</p>
          <h2>Shop wrappers by region, tribe, and craftsmanship.</h2>
          <p>
            Discover fresh arrivals from all six geopolitical zones, with every design tied to a real vendor, location,
            and cultural story.
          </p>
          <div className="hero-badges">
            <span>120 curated products</span>
            <span>Vendor-led sourcing</span>
            <span>Quote-ready shopping</span>
          </div>
        </div>

        <div className="hero-panel">
          <p className="panel-label">Current zone</p>
          <h3>{activeZoneData.title}</h3>
          <p>{activeZoneData.description}</p>
          <button className="panel-toggle" onClick={() => setShowZonePanel((prev) => !prev)}>
            {showZonePanel ? 'Hide zone panel' : 'Open zone panel'}
          </button>
        </div>
      </div>

      <div className="wrappers-layout">
        <aside className={`zone-sidebar ${showZonePanel ? 'open' : 'collapsed'}`}>
          <div className="sidebar-header">
            <div>
              <p className="sidebar-label">Pick a zone</p>
              <h3>Geographical zones</h3>
            </div>
            <button className="sidebar-toggle" onClick={() => setShowZonePanel((prev) => !prev)}>
              ☰
            </button>
          </div>

          <div className="zone-list">
            {zones.map((zone) => (
              <button
                key={zone.id}
                className={`zone-pill ${activeZone === zone.id ? 'active' : ''}`}
                onClick={() => setActiveZone(zone.id)}
              >
                <span className="zone-pill-emoji">{zone.emoji}</span>
                <span className="zone-pill-copy">
                  <strong>{zone.title}</strong>
                  <small>{zone.short}</small>
                </span>
              </button>
            ))}
          </div>
        </aside>

        <main className="zone-content" style={{ backgroundColor: '#000000', backgroundImage: 'none' }}>
          <div className="zone-header">
            <div>
              <p className="eyebrow">{activeZoneData.title} • {activeZoneData.short}</p>
              <h3>{activeZoneData.title} wrappers and new arrivals</h3>
              <p>{activeZoneData.description}</p>
            </div>
            <div className="zone-metrics">
              <div>
                <strong>20</strong>
                <span>fresh cards</span>
              </div>
              <div>
                <strong>{activeZoneData.tribes.length}</strong>
                <span>major tribes</span>
              </div>
            </div>
          </div>

          <div className="tribe-strip">
            {activeZoneData.tribes.map((tribe) => (
              <span key={tribe} className="tribe-chip">{tribe}</span>
            ))}
          </div>

          {quoteMessage && <div className="quote-toast">{quoteMessage}</div>}

          <div className="products-grid" style={{ backgroundColor: '#000000' }}>
            {activeZoneData.products.map((product) => (
              <article key={product.id} className="product-card">
                <div className="product-card-top">
                  <span className="product-badge">New arrival</span>
                  <span className="product-price">₦{product.price.toLocaleString()}</span>
                </div>

                <img src={product.image} alt={product.name} className="product-image" />

                <h4>{product.name}</h4>
                <p className="product-story">Handpicked for modern styling, cultural pride, and premium finish.</p>

                <div className="product-meta">
                  <div>
                    <span>Vendor</span>
                    <strong>{product.vendor}</strong>
                  </div>
                  <div>
                    <span>Location</span>
                    <strong>{product.location}</strong>
                  </div>
                  <div>
                    <span>Tribe</span>
                    <strong>{product.tribe}</strong>
                  </div>
                  <div>
                    <span>Yards</span>
                    <strong>{product.measurement}</strong>
                  </div>
                </div>

                <div className="product-actions">
                  <button className="buy-btn" onClick={() => handlePurchase(product)}>
                    Buy Now
                  </button>
                  <button className="quote-btn" onClick={() => handleQuoteRequest(product)}>
                    Request Quote
                  </button>
                </div>
              </article>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}

export default Wrappers;
